<template>
	<div>
		<div class="menuTool" style="width:100%;">
			<div class="search-title">
				仪表账单
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.sn" placeholder="请输入订单号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.roomName" placeholder="请输入房间号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.roomCusName" placeholder="请输入业主名" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-select size="small" v-model="query.meterType" placeholder="仪表类型" clearable>
					<el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="search-input-item">
				<el-select size="small" v-model="query.payMode" placeholder="收费方式" clearable>
					<el-option v-for="item in payMode" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="search-input-item">
				<el-select size="small" v-model="query.refundStatus" placeholder="退款状态" clearable>
					<el-option v-for="item in refundStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="search-input-item">
				<el-select size="small" v-model="query.autoFlag" placeholder="是否智能表" clearable>
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="search-input-item">
				<el-date-picker
					v-model="query.dataRange"
					type="daterange"
					align="right"
					size="small"
					style="width: 410px"
					value-format="yyyy-MM-dd"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
				>
				</el-date-picker>
			</div>
			<div class="search-button-tools">
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.order.listPage'" :loading="tableLoading" @click="doSearch">查询</el-button>
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.order.export'" v-debounce @click="doExport">导出</el-button>
			</div>
			<el-table :data="tableData" row-key="id" border :stripe="true" v-loading="tableLoading" tooltip-effect="light">
				<el-table-column width="200" prop="sn" label="订单号"></el-table-column>
				<el-table-column width="200" show-overflow-tooltip prop="payMeterNo" label="表号"></el-table-column>
				<el-table-column width="200" show-overflow-tooltip prop="actualNo" label="实际表号"></el-table-column>
				<el-table-column width="160" show-overflow-tooltip prop="mainNo" label="主表号"></el-table-column>
				<el-table-column width="100" prop="meterType" label="类型"></el-table-column>
				<el-table-column width="160" show-overflow-tooltip prop="projectName" label="项目小区"></el-table-column>
				<el-table-column width="200" show-overflow-tooltip prop="floorName" label="楼栋"></el-table-column>
				<el-table-column width="100" show-overflow-tooltip prop="roomName" label="房间号"></el-table-column>
				<el-table-column width="150" show-overflow-tooltip prop="roomCusName" label="业主名"></el-table-column>
				<el-table-column width="180" prop="invoiceTime" label="开票时间"></el-table-column>
				<el-table-column width="150" prop="payAmount" label="缴费金额" align="right"></el-table-column>
				<el-table-column width="100" prop="payTypeStr" label="支付方式"></el-table-column>
				<el-table-column width="180" prop="payTime" label="支付时间"></el-table-column>
				<el-table-column width="100" prop="chargeStatusStr" label="充值状态"></el-table-column>
				<el-table-column width="100" prop="refundStatusStr" label="退款状态"></el-table-column>
				<el-table-column width="150" show-overflow-tooltip prop="remarks" label="备注"></el-table-column>
				<el-table-column width="200" fixed="right" label="操作">
					<template slot-scope="scope">
						<el-button v-Jurisdiction="'hydropower.web.charge.order.lookInvoice'" @click="doOpenInvoice(scope.row)" type="text" size="small">凭证</el-button>
						<el-button v-Jurisdiction="'hydropower.web.charge.order.updateInvoice'" @click="doOpenEdit(scope.row)" type="text" size="small">修改</el-button>
						<el-button v-Jurisdiction="'hydropower.web.charge.order.offlineRefund'" v-show="showRefund(scope.row)" @click="doOpenOfflineRefund(scope.row)" type="text" size="small">退款</el-button>
					</template>
				</el-table-column>
			</el-table>
			<simple-pagination @search="doSearch" />
		</div>

		<el-dialog :title="invoiceDlg.title" :visible.sync="invoiceDlg.visible" v-if="invoiceDlg.visible" width="88%" :destroy-on-close="true">
			<invoice :orderId="invoiceDlg.orderId"></invoice>
		</el-dialog>

		<el-dialog :title="editDlg.title" :visible.sync="editDlg.visible" v-if="editDlg.visible" width="500px" :destroy-on-close="true">
			<edit-invoice-info-form :defaultFormData="editDlg.formData" @search="doSearch"></edit-invoice-info-form>
		</el-dialog>

		<el-dialog
			:title="offlineRefundDlg.title"
			:visible.sync="offlineRefundDlg.visible"
			v-if="offlineRefundDlg.visible"
			width="45%"
			:destroy-on-close="true"
		>
			<offline-refund-form :defaultFormData="offlineRefundDlg.formData" @search="doSearch"></offline-refund-form>
		</el-dialog>
	</div>
</template>

<script>
import "@/assets/scss/common.scss";
import { useStatus, options, meterType, payMode, refundStatus } from "@/dict/meterDict";
import mixin from "@/mixin/index";
import { pick, assign } from "lodash";
import Invoice from "./Invoice.vue";
import OfflineRefundForm from "./OfflineRefundForm.vue";
import EditInvoiceInfoForm from "./EditInvoiceInfoForm.vue";

export default {
	name: "PaidTable",
	components: { Invoice, OfflineRefundForm, EditInvoiceInfoForm },
	mixins: [mixin],
	props: {
		parentData: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
	data() {
		return {
			useStatus,
			options,
			meterType,
			payMode,
			refundStatus,
			queryListUrl: "/meter/web/order/listPage",
			invoiceDlg: {
				title: "凭证",
				visible: false,
			},
			editDlg: {
				title: "",
				visible: false,
				formData: {},
			},
			offlineRefundDlg: {
				title: "",
				visible: false,
				formData: {},
			},
		};
	},
	methods: {
		doSearch() {
			this.getList();
		},
		doExport() {
			const title = "已支付订单数据";
			const url = "meter/web/order/export";
			this._export(title, url);
		},
		doOpenInvoice(row) {
			this.invoiceDlg = {
				visible: true,
				title: "凭证",
				orderId: row.id,
			};
			// this.$router.push({
			//     name: 'MeterOrderInvoiceIndex',
			//     params: {
			//         orderId: row.id
			//     }
			// })
		},
		doOpenOfflineRefund(row) {
			const formData = {
				id: row.id,
				payAmount: row.request,
				payReAmount: row.response,
				refundReason: row.refundReason,
			};
			this.offlineRefundDlg = {
				visible: true,
				title: "线下退款",
				formData: formData,
			};
		},
		doOpenEdit(row) {
			this.editDlg = {
				title: `修改订单${row.sn}信息`,
				visible: true,
				formData: pick(row, ["id", "invoiceNo", "invoiceTime"]),
			};
		},
		showRefund(row) {
			return row.refundStatus == 0 && row.payType == "offline" && row.chargeStatus == 1 && row.payStatus == 1;
		},
		selectNode(data) {
			this.query = assign(this.query, data);
			this.doSearch();
		},
	},
	watch: {
		parentData(val) {
			this.query = assign(this.query, this.parentData);
			this.doSearch();
		},
	},
	mounted() {
		this.query = assign(this.query, this.parentData);
		this.doSearch();
	},
};
</script>
